import AgentsDashboardProfil from '../../../features/supervision/agentsDashboard/components/AgentsDashboardProfil/AgentsDashboardProfil';
import { PageTable, Header } from '/src/layouts/page';
import { useParams } from "react-router-dom";

function AgentDashboardPage() {
    const params = useParams();
    return (
        <PageTable>

            <>
                <Header title={<span>{"Compliance Performance Dashboard"}</span>}></Header>
                <AgentsDashboardProfil />
            </>


        </PageTable>
    );
}

export default AgentDashboardPage;